import { DashOutlined } from '@ant-design/icons'
import { Modal } from 'antd'
import React from 'react'
import { $t } from '~/i18n.js'
import { colors } from '~/theme/colors.js'
import { ParseMessage } from '../atom/parseMessage.jsx'

export const ReadMore = ({ text, maxLength=25, hideMore=false }) => {
  if (!text) return ''
  return (
    <p style={{ maxWidth: 200, marginBottom: 0 }}>
      <ParseMessage message={text.substr(0, (maxLength || 35))}/>
      {text.length > (maxLength || 35) &&
        <span className={hideMore ? '' : 'clickable'} onClick={hideMore ? null : (e) => {
          e.preventDefault()
          Modal.info({ content: <ParseMessage message={text} />, icon: <DashOutlined />, okText: $t('Sluit') })
        }
        }>
          ... {!hideMore && <span style={{ color: colors.primary }}> {$t('meer')}</span>}
        </span>}
    </p>
  )
}
